/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { withPreference } from '@bingads-webui-react/preference-context';
import { withCurrentExpandedScope } from '@bingads-webui-campaign-react/use-current-scope-entity';

const NewUICampaignHistoryPreferenceKey = 'WebApp.Next.CampaignHistory';
const CampaignHistoryNumber = 4;

export class CampaignHistoryRecorderRaw extends React.Component {
  constructor(props) {
    super(props);
    const {
      preferenceService,
      instrumentation,
    } = props;

    this.preferenceSetLogger = instrumentation.newUINavigation.create().preferenceSet.create();
    // explicit start and stop signal
    this.preferenceSetLogger.startSignal();
    this.preferenceService = preferenceService;
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.currentCampaign) {
      return true;
    }
    return false;
  }

  render() {
    const { currentCampaign } = this.props;
    if (currentCampaign) {
      let campaignHistoryPreference = this.preferenceService.findByNameAtAccountLevel(NewUICampaignHistoryPreferenceKey) &&
        this.preferenceService.findByNameAtAccountLevel(NewUICampaignHistoryPreferenceKey).Data;
      if (!campaignHistoryPreference) {
        campaignHistoryPreference = [];
      }
      const index = campaignHistoryPreference.findIndex(campaign => campaign.Id === currentCampaign.Id);
      if (index !== -1) {
        campaignHistoryPreference.splice(index, 1);
      } else if (campaignHistoryPreference.length === CampaignHistoryNumber) {
        campaignHistoryPreference.pop();
      }
      campaignHistoryPreference.unshift(currentCampaign);
      this.preferenceService.setAtAccountLevel({
        Name: NewUICampaignHistoryPreferenceKey,
        Data: campaignHistoryPreference,
      });
    }
    return (null);
  }
}

CampaignHistoryRecorderRaw.propTypes = {
  preferenceService: PropTypes.shape({}).isRequired,
  currentCampaign: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  instrumentation: PropTypes.object.isRequired,
};
CampaignHistoryRecorderRaw.defaultProps = {
  currentCampaign: undefined,
};

export const CampaignHistoryRecorder =
  withPreference(withCurrentExpandedScope(withInstrumentation(CampaignHistoryRecorderRaw)));
